import { Link as MuiLink } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'SearchLoadMore' })({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

interface SearchLoadMoreProps {
  readonly onClick: () => void;
}

export const SearchLoadMore: React.FC<SearchLoadMoreProps> = ({ onClick }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <MuiLink
        id="sda-load-more-button"
        aria-label="load more results"
        role="button"
        onClick={onClick}
        variant="subtitle1"
      >
        Load 10 more
      </MuiLink>
    </div>
  );
};
